import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom';
import App from './router';
import './scss/stylesheet.scss';
import ScrollToTop from './js/functions/scrollToTop';
import {YMInitializer} from 'react-yandex-metrika';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <YMInitializer accounts={[95251135]} options={{webvisor: true}} />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
